import { makeStyles } from '@material-ui/core/styles';

const useAddSpendModalStyles = makeStyles((theme) => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 24,
    },
    paper: {
        width: 760,
        maxWidth: 'calc(100vw - 48px)',
        height: 'min(78vh, 720px)',
        maxHeight: 'calc(100vh - 48px)',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        backgroundColor: '#fff',
        borderRadius: 10,
        boxShadow: '0 18px 50px rgba(25, 32, 56, 0.22)',
        outline: 'none',
        [theme.breakpoints.down('sm')]: {
            width: '100%',
            maxWidth: 'calc(100vw - 24px)',
            height: 'calc(100vh - 24px)',
            maxHeight: 'calc(100vh - 24px)',
        },
    },
    header: {
        minHeight: 58,
        padding: '12px 20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderBottom: '1px solid #E9EBF5',
        backgroundColor: '#FAFAFE',
        boxSizing: 'border-box',
        flexShrink: 0,
    },
    title: {
        color: '#2B2C35',
        fontSize: 16,
        fontWeight: 600,
        lineHeight: '22px',
    },
    subtitle: {
        marginTop: 2,
        color: '#78798E',
        fontSize: 12,
        lineHeight: '17px',
    },
    closeButton: {
        width: 32,
        height: 32,
        color: '#78798E',
    },
    form: {
        display: 'grid',
        gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
        alignContent: 'start',
        gap: '16px 20px',
        padding: 20,
        overflowY: 'auto',
        flex: 1,
        minHeight: 0,
        backgroundColor: '#fff',
        [theme.breakpoints.down('sm')]: {
            gridTemplateColumns: '1fr',
            padding: 16,
        },
    },
    formItem: {
        minWidth: 0,
        display: 'flex',
        flexDirection: 'column',
        gap: 6,
    },
    label: {
        color: '#424242',
        fontSize: 12,
        fontWeight: 500,
        lineHeight: '17px',
    },
    helper: {
        color: '#AFB0BF',
        fontSize: 11,
        lineHeight: '15px',
    },
    footer: {
        minHeight: 60,
        padding: '12px 20px',
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        gap: 10,
        borderTop: '1px solid #E9EBF5',
        backgroundColor: '#FAFAFE',
        boxSizing: 'border-box',
        flexShrink: 0,
    },
    cancelButton: {
        minWidth: 82,
        height: 34,
        color: '#3F51B5',
        borderColor: '#3F51B5',
        borderRadius: 4,
        boxShadow: 'none',
        textTransform: 'none',
    },
    saveButton: {
        minWidth: 82,
        height: 34,
        color: '#fff',
        backgroundColor: '#3F51B5',
        borderRadius: 4,
        boxShadow: 'none',
        textTransform: 'none',
        '&:hover': {
            backgroundColor: '#35469F',
            boxShadow: 'none',
        },
    },
    inputRoot: {
        height: 36,
        borderRadius: 4,
        backgroundColor: '#fff',
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#D5D6DD',
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#9FA3B8',
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#3F51B5',
        },
    },
    selectField: {
        height: 36,
    },
}));

export default useAddSpendModalStyles;
